// import { IFacetAlert } from '@/@types/client-api';
import { IFacetAlert } from '@/@types/client-api';
import { ClientAPI } from '@/redux/api';

const facetAlertsServiceEndpoints = ClientAPI.injectEndpoints({
  endpoints: builder => ({
    getFacetAlerts: builder.query<IFacetAlert[], void>({
      query: () => ({
        url: '/facetAlerts',
        method: 'GET'
      })
    })
  })
});

export const { useGetFacetAlertsQuery } = facetAlertsServiceEndpoints;

export default facetAlertsServiceEndpoints;
